import React from 'react';
import ProductLaunch from '../Product';
import { SneakLaunchResponse } from '~/services/sneaker-release/sneaker-release.type';
import { QUERY_GET_OPTHER_RELEASE, QUERY_GET_RELEASE_PRODUCT } from '../graphql';
import { useQuery } from '@apollo/client';
import { transformReleaseProduct } from '~/services/sneaker-release/sneaker-release-transform';
import ProductItemLaunch from '../Product/Item';

type Props = {
    brandCode: string;
};

const OtherRelease = ({ brandCode }: Props) => {
    const { data: fetchReleaseProduct, loading } = useQuery<SneakLaunchResponse>(QUERY_GET_OPTHER_RELEASE, {
        variables: {
            page: 1,
            pageSize: 4,
            brand: brandCode,
            releaseDate: 'DESC'
        },
        skip: !brandCode
    });
    const products = fetchReleaseProduct?.getReleaseProducts?.items?.map((i) => transformReleaseProduct(i)) || [];
    return (
        <div className="flex flex-col gap-5">
            <h2 className="font-bold text-4xl" style={{ lineHeight: 'unset' }}>
                Other Releases
            </h2>

            <section className="grid grid-cols-12 gap-4 md:gap-6 mx-auto md:gap-y-4 w-full">
                <div className="col-span-full grid grid-cols-12 gap-4 md:gap-6">
                    {products?.map((product, index) => {
                        return <ProductItemLaunch key={index} product={product} loading={loading} skip={true} />;
                    })}
                </div>
            </section>
        </div>
    );
};

export default OtherRelease;
